import { takeLatest, call, put } from 'redux-saga/effects'
import myCoursesList from 'api/home/MyCourses'
import * as fromActions from '../../actions/courses.action'

async function getMyList() {
  return await myCoursesList({})
}

function* myCoursesListEffectSaga() {
  try {
    const data = yield call(getMyList)
    yield put(fromActions.Actions.coursesUserMyListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* myCoursesListWatcherSaga() {
  yield takeLatest(fromActions.COURSES_USER_GET_MY_LIST, myCoursesListEffectSaga)
}
